import React, { useEffect, useState } from "react";
import { request } from "./common/js/http.js";
import Loading from "./components/Loading.js";
import Watermark from "@uiw/react-watermark";
import { useTranslation } from "react-i18next";

export default function DocumentDetail() {
  const { t } = useTranslation();

  const [doc, setDoc] = useState();
  const [chatDocGPTStatus, setChatDocGPTStatus] = useState(0);
  const [documentName, setDocumentName] = useState();
  const [iframeLoading, setIframeLoading] = useState(true);

  useEffect(() => {
      getFileDetail();
  }, []);

  const getFileDetail = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    const query = new URLSearchParams(window.location.search);
    const id = query.get("documentId");
      var url = `api/v1/documents/${id}`;
    url += "?timezoneOffset=" + new Date().getTimezoneOffset();
    request({
      url: url,
        method: "get",

    }).then((res) => {
      if (res.statusCode === 403) {
        //navigate(`/403?returnurl=${window.location.pathname}`, { replace: false });
        return;
      }
      if (res.statusCode) {
        global.constants.errCode = res.statusCode;
        //navigate('/error', { replace: true });
        return;
        }
       
      if (res.success && res.result) {
          let result = res.result;
          console.log(result);
          setDoc(result);
        document.title = result.name;
        setDocumentName(result.name);
      }
    });
  };

  //Chat Height
  const areaMaxHeight = () => {
    return  "100vh";
  };
  const handleIframeLoad = () => {
    setIframeLoading(false);
  };

  const pdfDocument = () => {
    return (
      <>
            <div className="documentDetail h-100">
                <Watermark
                    gapX={15}
                    width={250}
                    gapY={250}
                    offsetTop={200}
                    height={10}
                    fontSize={doc.watermarkFontSize}
                    rotate={doc.watermarkRotate}
                    fontColor={doc.watermarkColor}
                    content={!doc.watermarkEnabled ? "" : doc.watermarkText}
                >
                    {doc.blobURL && (
                        <>
                            {iframeLoading && (
                                <div className="h-100 w-100 d-flex align-items-center justify-content-center position-absolute">
                                    <Loading />
                                </div>
                            )}
                            <iframe
                                frameBorder="0"
                                onLoad={handleIframeLoad}
                                style={{ width: "100%", height: "100vh" }}
                                src={doc.blobURL}
                            ></iframe>
                        </>
                    )}
                </Watermark>
           
        </div>
      </>
    );
  };

  const wordDocument = () => {
    return (
      <>
        <div className="documentDetail h-100">
           <Watermark
                gapX={15}
                width={250}
                gapY={250}
                offsetTop={200}
                height={10}
                fontSize={doc.watermarkFontSize}
                rotate={doc.watermarkRotate}
                fontColor={doc.watermarkColor}
                content={!doc.watermarkEnabled ? "" : doc.watermarkText}
              >
                {doc.previewDisabled ? (
                  <div style={{ padding: "40px" }}>{t("PreviewDisabled")}</div>
                ) : (
                  <iframe
                    id="wordIframe"
                    style={{ width: "100%", height: "100vh" }}
                    src={
                      "https://view.officeapps.live.com/op/embed.aspx?src=" +
                      encodeURIComponent(doc.blobURL)
                    }
                  ></iframe>
                )}{" "}
              </Watermark>
        </div>
      </>
    );
  };

  //根据文件类型显示不同内容
  const content = () => {
    var blobURL = doc?.blobURL;
    if (blobURL) {
      const url = blobURL.toLocaleLowerCase();
      var content = null;
      if (
        url.indexOf(".png") > -1 ||
        url.indexOf(".jpg") > -1 ||
        url.indexOf(".jpeg") > -1
      ) {
        content = imageDocument();
      } else if (url.indexOf(".pdf") > -1) {
        content = pdfDocument();
      } else if (url.indexOf(".doc") > -1) {
        content = wordDocument();
      }
      return <div className="content h-100">{content}</div>;
    } else {
      return (
        <div className="content h-100">
          <Loading />
        </div>
      );
    }
  };

  const imageDocument = () => {
    let maxHeight = areaMaxHeight();
    return (
      <>
        <div className="documentDetail h-100">
           <Watermark
                gapX={15}
                width={250}
                gapY={250}
                offsetTop={200}
                height={10}
                fontSize={doc.watermarkFontSize}
                rotate={doc.watermarkRotate}
                fontColor={doc.watermarkColor}
                content={!doc.watermarkEnabled ? "" : doc.watermarkText}
              >
                {doc.previewDisabled ? (
                  <div style={{ padding: "40px" }}>{t("PreviewDisabled")}</div>
                ) : (
                  <>
                    {doc.blobURL && (
                      <img
                        src={doc.blobURL}
                        style={{ maxWidth: "100%", maxHeight: maxHeight }}
                        alt=""
                      />
                    )}
                  </>
                )}
              </Watermark>
        </div>
      </>
    );
  };

  return (
    <>
      <div
        id="divBlur"
        style={{
          height: "100%",
        }}
        align="center"
        className={`${chatDocGPTStatus > 0 ? "" : "ml-2 mr-2 pb-2"}`}
      >
        <div
          className="h-100"
          style={{
            maxWidth: "100%",
          }}
        >
          {content()}
        </div>
      </div>
    </>
  );
}
